import { getShowNetworkTimezone, ReadableDifference, ShowRunOutWarningClass } from '@utils/general'
import { dayjsWithTimezone, formatters } from '@utils/intl/dateTimeFormatters'
import { Col, Row } from 'antd'
import classNames from 'classnames'
import dayjs from 'dayjs'

export const normalizeDispatchDate = (
  date: string | Date | null,
  showNow = false,
  timeZone: Intl.DateTimeFormatOptions['timeZone'] = undefined
) => {
  const today = dayjsWithTimezone(undefined, timeZone).startOf('day')
  let dispatchWindow = showNow ? 'Now' : formatters.WEEKDAY_MONTH_DATE_TIME(dayjs(date), timeZone)

  if (date) {
    const dispatchWindowDate = getShowNetworkTimezone({ timeZone }) ? dayjsWithTimezone(date, timeZone) : dayjs(date)
    const formattedDispatchWindowDate = formatters.DATE(dispatchWindowDate, timeZone)
    if (!dispatchWindowDate.isBefore(today)) {
      const formattedTomorrow = formatters.DATE(today.clone().add(1, 'd'), timeZone)
      const numberOfDays = Math.abs(today.diff(dispatchWindowDate, 'days'))
      const daysAreEqual = formatters.DATE(today, timeZone) === formattedDispatchWindowDate
      const dayIsTomorrow = formattedDispatchWindowDate === formattedTomorrow
      const lessThanAWeekAndDayThreeThroughSeven = numberOfDays <= 7
      if (daysAreEqual) {
        dispatchWindow = `Today ${formatters.TIME(dispatchWindowDate, timeZone)}`
      } else if (dayIsTomorrow) {
        dispatchWindow = `Tom. ${formatters.TIME(dispatchWindowDate, timeZone)}`
      } else if (lessThanAWeekAndDayThreeThroughSeven) {
        dispatchWindow = formatters.DAY_TIME(dispatchWindowDate, timeZone)
      } else {
        dispatchWindow = formatters.MONTH_DATE_TIME(dispatchWindowDate, timeZone)
      }
    }
  }

  return dispatchWindow
}
export const formatTimeWindow = (
  start: string | Date | null,
  end: string | Date | null,
  showNow = true,
  isLoadWindow = false,
  timeZone?: string
) => {
  return `${normalizeDispatchDate(start, showNow, timeZone)} - ${normalizeDispatchDate(
    end,
    showNow && !isLoadWindow,
    timeZone
  )}`
}

type OrderWindowTagProps = {
  window: string
  isLoadingWindow?: boolean
}

export function OrderWindowTag({ window, isLoadingWindow }: OrderWindowTagProps) {
  let newWindow = window
  if (window.includes(' am')) {
    newWindow = window.replaceAll(' am', ' AM')
  }
  if (window.includes(' pm')) {
    newWindow = newWindow.replaceAll(' pm', ' PM')
  }
  return (
    <div style={{ whiteSpace: 'break-spaces', wordWrap: 'break-word' }}>
      <Row>
        <Col span={24} className='window-value pl-2'>
          <span
            className={classNames(
              { 'loading-window-tag': isLoadingWindow },
              { 'dispatch-window-tag': !isLoadingWindow },
              { 'in-window': window.includes('Now') }
            )}
          >
            {newWindow}
          </span>
        </Col>
      </Row>
    </div>
  )
}

// TODO Delete
export function FormatRunoutTime({ order }) {
  return (
    <Row>
      <Col>
        <b className={ShowRunOutWarningClass(order.dispatch_window_end)}>
          {ReadableDifference(order.dispatch_window_end, undefined, true, order.type?.toLowerCase() === 'backhaul')}
        </b>
      </Col>
    </Row>
  )
}
